module.exports = __webpack_public_path__ + "media/images/recruitment/landing/feature03-a130b86f4718053d5be1ea6f3085b0db.svg";